export default __webpack_public_path__ + "static/media/uc.191096d6.png";